<template>

  <div v-if="notifications">
    <notification-list
      @hideModal="hide()" 
      @deleted="hide()">
      </notification-list>
  </div>
  
</template>

<script>
import NotificationList from './NotificationList'

export default {
  name: 'NotificationObserver',
  components: {
    NotificationList
  },
  data () {
    return {
    }
  },
  computed: {
    notifications () {
      return this.$route.query.notifications
    }
  },
  created () {
  },
  methods: {
    hide () {
      this.$changeUrlParam({
        notifications: undefined
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Notification/NotificationObserver.vue